import styled from 'styled-components';

const IndustryIndividualTemplateStyle = styled.section`
	--keyNumbersDistance: 140px;

	&.key-numbers-variant {
		.global-hero-section {
			.section {
				margin-bottom: var(--keyNumbersDistance);
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--keyNumbersDistance: var(--sp13x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--keyNumbersDistance: var(--sp11x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--keyNumbersDistance: var(--sp10x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--keyNumbersDistance: var(--sp9x);
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--keyNumbersDistance: var(--sp8x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--keyNumbersDistance: var(--sp3x);
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--keyNumbersDistance: var(--sp3x);
	}
`;

export default IndustryIndividualTemplateStyle;
